import axios from "axios";

import { logError } from "@Helpers/logger.js";
import { HttpRouter } from "@Modules/shared/interfaces/HttpRouter";

export type NotificationsApi = {
  markNotificationAsRead: (id: string) => Promise<boolean>
  setRouter: (router: HttpRouter<"put">) => NotificationsApi
}

/**
 * Talks to the notification endpoints the app serves a signed-in user. Only the
 * read flag is here; the notification list itself is still loaded by the legacy
 * Vuex store.
 */
export default function NotificationsApi(): NotificationsApi {
  let router: HttpRouter<"put"> = axios;

  const that: NotificationsApi = {
    /**
     * Marks one notification read, answering whether the server took it. The
     * endpoint accepts a list, and a single id is all any caller has needed.
     */
    markNotificationAsRead: async function (id: string): Promise<boolean> {
      try {
        await router.put("/app/api/notifications/read", { notifications: [id] });

        return true;
      } catch (error) {
        logError(`Failed to mark notification ${id} as read`);

        return false;
      }
    },

    /**
     * Allows you to swap out the router for a fake one when writing tests
     */
    setRouter(newRouter: HttpRouter<"put">) {
      router = newRouter;

      return that;
    },
  };

  return that;
}
